var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item)?_c('DetailCard',{attrs:{"headContent":_vm.payContent,"detailContent":_vm.detailContent,"detailLarge":true},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"column col-auto"},[_vm._v(_vm._s(_vm.title))])]},proxy:true}],null,false,1037647694)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }